import Settings from "@db/table/Settings/table";
export { Settings };
export default {
  Settings
};